export const screenWidth = 640;
export const screenHeight = 480;
export const charaSize = 48;
